(function() {
  var PRODUCTS = [
    {
      id: 15, cat: 'spiel',
      platform: 'PlayStation 5',
      title: 'Grand Theft Auto VI',
      desc: 'Das meistgehypte Spiel aller Zeiten: Rockstar Games führt euch nach Leonida, das größte und lebendigste GTA-Universum bisher – inklusive Code in the Box für sofortigen Download.',
      release: '2026-11-19',
      price: '79,99 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/Official_Cover_Art_square.jpg?v=1783745718',
      icon: '🌴',
      brand: 'Rockstar Games'
    },
    {
      id: 1, cat: 'spiel',
      platform: 'PlayStation 5',
      title: 'The Blood of Dawnwalker',
      desc: 'The Blood of Dawnwalker ist eines der meist erwarteten Action-RPGs 2026.',
      release: '2026-09-03',
      price: 'ab ca. 80 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/The_Blood_of_Dawnwalker_cover_art.jpg?v=1782331049',
      url: 'https://www.videogamepalace.at/products/blood-of-dawnwalker-ps5-neu',
      icon: '🎮',
      brand: 'Rockstar Games'
    },
    {
      id: 2, cat: 'spiel',
      platform: 'PlayStation 5',
      title: "Marvel's Wolverine",
      desc: 'Insomniac Games bringt Logan endlich ins Rampenlicht. Brutales Action-Adventure vom Team hinter Spider-Man.',
      release: '2026-09-15',
      price: 'ab ca. 80 €',
      preorder: true,
      url: 'https://www.videogamepalace.at/products/marvels-wolverine-ps5-neu',
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_3432e322-c80c-4e4b-87c8-d0add32e0c62.jpg?v=1781328219',
      icon: '🦾',
      brand: 'Insomniac Games'
    },
    {
      id: 3, cat: 'spiel',
      platform: 'PlayStation 5',
      title: 'Phantom Blade 0',
      desc: 'Atemberaubendes Martial-Arts-Action-RPG im Dark-Fantasy-Setting. Einer der meist erwarteten PS5-Titel des Jahres.',
      release: '2026-10-29',
      price: 'ab ca. 70 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_7570a669-738f-436d-b2d6-12a54ccb105e.jpg?v=1781328219',
      icon: '⚔️',
      brand: 'S-GAME'
    },
    {
      id: 4, cat: 'spiel',
      platform: 'Xbox Series X',
      title: 'Gears of War: E-Day',
      desc: 'Das Prequel zur Original-Trilogie. Marcus Fenix und Dom Santiago kämpfen am ersten Tag der Locust-Invasion.',
      release: '2026-10-06',
      price: 'ab ca. 70 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_e04c6203-4f28-4c66-9758-8a71187dad32.jpg?v=1781328219',
      icon: '💥',
      brand: 'The Coalition'
    },
    {
      id: 5, cat: 'spiel',
      platform: 'PlayStation 5',
      title: 'Onimusha: Way of the Sword',
      desc: 'Nach 20 Jahren Pause ist Capcom zurück! Samurai-Action-Horror im feudalen Edo-zeitlichen Kyoto – mit dem RE Engine und Musashi Miyamoto als Protagonist.',
      release: '2026-09-01',
      price: 'ab ca. 80 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_ec7216ec-6366-4826-b3ad-3a194697514d.jpg?v=1781328220',
      url: 'https://www.videogamepalace.at/products/onimusha-way-of-the-sword-ps5-neu',
      icon: '⛩️',
      brand: 'Capcom'
    },
    {
      id: 6, cat: 'spiel',
      platform: 'PlayStation 5',
      title: 'Ace Combat 8: Wings of Theve',
      desc: 'Nach 7 Jahren endlich wieder in der Luft! Bandai Namco schickt euch als Elite-Pilot in epische Luftkämpfe – mit Unreal Engine 5 und über 30 Flugzeugen.',
      release: '2026-10-02',
      price: 'ab ca. 80 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_09f380bc-155b-40c9-82ae-5c6ae8f188e6.jpg?v=1781328219',
      icon: '✈️',
      brand: 'Bandai Namco'
    },
    {
      id: 7, cat: 'spiel',
      platform: 'PlayStation 5 · Xbox Series X',
      title: 'Tomb Raider: Legacy of Atlantis',
      desc: 'Crystal Dynamics reimaginiert Lara Crofts 1996er Debüt mit Unreal Engine 5. Jetzt offiziell auf Februar 2027 verschoben – vormerken lohnt sich!',
      release: '2027-02-12',
      price: 'ab ca. 70 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_81121cb2-053a-4c3a-9fec-5f6243bcbc78.jpg?v=1781328220',
      icon: '🏺',
      brand: 'Crystal Dynamics'
    },
    {
      id: 8, cat: 'spiel',
      platform: 'PlayStation 5 · Nintendo Switch 2',
      title: 'Final Fantasy VII Revelation',
      desc: 'Das große Finale der FF7 Remake-Trilogie. Cloud, Tifa, Vincent & Co. im epischen Endkampf gegen Sephiroth – simultan auf allen Plattformen. Spring 2027.',
      release: '2027-03-31',
      price: 'ab ca. 70 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_b7177189-36d6-4113-9b54-25a94703b695.jpg?v=1781328220',
      icon: '🌌',
      brand: 'Square Enix'
    },
    {
      id: 9, cat: 'tonie',
      platform: 'Toniebox · Toniebox 2',
      title: 'Pokémon Tonies',
      desc: 'Offiziell! Pokémon kommt auf die Toniebox. Pikachu & Co. bringen Abenteuer und Musik ins Kinderzimmer – eine der heißesten Kollaborationen 2026.',
      release: '2026-08-20',
      price: 'ca. 20 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_667e415e-dd38-4f9f-ad3f-093f425bca4c.jpg?v=1781328219',
      url: 'https://www.videogamepalace.at/products/pokemon-tonie-set-4er-neu',
      icon: '⚡',
      brand: 'Tonies'
    },
    {
      id: 10, cat: 'tonie',
      platform: 'Toniebox · Toniebox 2',
      title: 'Bluey 3er-Set',
      desc: 'Bluey, Bingo und Muffin gibt es in Kürze auch zum Hören! Die drei kommen direkt als Set auf eure Toniebox.',
      release: '2026-10-31',
      price: 'ca. 45 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/d66a09d2-dd77-4220-8b34-f480339d87cd.jpg?v=1782807061',
      url: '',
      brand: 'Tonies'
    },
    {
      id: 11, cat: 'tonie',
      platform: 'Toniebox · Toniebox 2',
      title: 'Ginny Tonie',
      desc: 'Die freche Ginny kommt auf die Toniebox! Hörspielabenteuer mit der beliebten Figur – perfekt für Kinder, die starke Charaktere lieben.',
      release: '2026-07-11',
      price: 'ca. 18 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_eb652f33-aed1-449a-a79a-7713fe2ae189.jpg?v=1781328219',
      url: 'https://videogamepalace.at/products/tonie-disney-superkitties-ginny-neu',
      brand: 'Tonies'
    },
    {
      id: 12, cat: 'tonie',
      platform: 'Toniebox · Toniebox 2',
      title: 'Book Tonie: Peter Pan',
      desc: 'Der Klassiker als Tonie – Peter Pan, Wendy und Captain Hook in einer spannenden Hörspielfassung für Kinder.',
      release: '2026-05-13',
      price: '9,99 €',
      preorder: false,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/c3127b7d-aeb8-456e-9085-11fa38ce89a6.jpg?v=1778739464',
      url: 'https://videogamepalace.at/products/book-tonie-peter-pan-abenteuer-auf-knopfdruck',
      brand: 'Tonies'
    },
    {
      id: 13, cat: 'konsole',
      platform: 'SNK · PLAION REPLAI',
      title: 'NeoGeo AES+',
      desc: 'Die Legende kehrt zurück! Die originale NeoGeo AES in 1:1 Nachbildung mit HDMI-Ausgang, kompatibel mit Original-Cartridges. Launch: 12. November 2026.',
      release: '2027-09-16',
      price: 'ab ca. 200 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_f104c5d6-9e07-4aca-a98b-f85b9584fd44.jpg?v=1781328219',
      icon: '🕹️',
      brand: 'SNK'
    },
    {
      id: 14, cat: 'konsole',
      platform: 'SNK · PLAION REPLAI',
      title: 'NeoGeo AES+ Anniversary Edition',
      desc: '35 Jahre NeoGeo – limitiertes Weiss-Design mit Arcade Stick und exklusiver Metal Slug Cartridge. Nur in begrenzter Stückzahl. Launch: 12. November 2026.',
      release: '2027-09-16',
      price: 'ab ca. 300 €',
      preorder: true,
      image: 'https://cdn.shopify.com/s/files/1/1023/9787/0425/files/rn-image_picker_lib_temp_611c4110-59b9-441b-b2bf-37109ad8637a.jpg?v=1781328219',
      icon: '👑',
      brand: 'SNK'
    }
  ];
 
  /* ══════════════════════════════════
     SCHEMA.ORG DYNAMISCH INJIZIEREN
  ══════════════════════════════════ */
  function injectSchema() {
    var items = PRODUCTS.map(function(p, i) {
      var priceRaw = p.price.replace(/[^0-9]/g, '') || '70';
      return {
        '@type': 'ListItem',
        'position': i + 1,
        'item': {
          '@type': 'Product',
          'name': p.title,
          'description': p.desc,
          'brand': { '@type': 'Brand', 'name': p.brand || 'Unbekannt' },
          'offers': {
            '@type': 'Offer',
            'priceCurrency': 'EUR',
            'price': priceRaw,
            'priceValidUntil': '2027-12-31',
            'availability': new Date(p.release) <= new Date()
              ? 'https://schema.org/InStock'
              : 'https://schema.org/PreOrder',
            'seller': { '@type': 'Organization', 'name': 'VideoGamePalace Wien' }
          }
        }
      };
    });
 
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      'name': 'Highlights H2 2026 – Must-Have Videospiele & Konsolen',
      'description': 'Die heißesten Releases des zweiten Halbjahres 2026 bei VideoGamePalace Wien',
      'url': 'https://www.videogamepalace.at/pages/highlights-2026',
      'numberOfItems': PRODUCTS.length,
      'itemListElement': items
    };
 
    var el = document.createElement('script');
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify(schema);
    document.head.appendChild(el);
  }
 
  /* ══════════════════════════════════
     RELEASE DATUM FORMATIEREN
  ══════════════════════════════════ */
  var MONATE = ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'];
 
  function formatRelease(dateStr) {
    var p = dateStr.split('-');
    return p[2].replace(/^0/,'') + '. ' + MONATE[+p[1]-1] + ' ' + p[0];
  }
 
  /* ══════════════════════════════════
     PREORDER MODAL
  ══════════════════════════════════ */
  function createModal() {
    if (document.getElementById('vgp-preorder-modal')) return;
 
    var style = document.createElement('style');
    style.textContent = [
      '#vgp-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.78);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);display:none;align-items:center;justify-content:center;z-index:99999;padding:16px;opacity:0;transition:opacity .3s ease}',
      '#vgp-modal-overlay.open{display:flex}',
      '#vgp-modal-overlay.visible{opacity:1}',
      '#vgp-preorder-modal{background:#0d1a20;border:1px solid rgba(0,229,255,.25);max-width:460px;width:100%;border-radius:4px;overflow:hidden;transform:translateY(20px);transition:transform .35s cubic-bezier(.22,1,.36,1);position:relative}',
      '#vgp-modal-overlay.visible #vgp-preorder-modal{transform:translateY(0)}',
      '.vgp-m-bar{height:3px;background:linear-gradient(90deg,#0d4f4f,#00e5ff,#ffd700,#00e5ff,#0d4f4f);background-size:300% 100%;animation:vgpMBar 3s linear infinite}',
      '@keyframes vgpMBar{to{background-position:300% 0}}',
      '.vgp-m-header{padding:18px 22px 14px;border-bottom:1px solid rgba(0,229,255,.15);display:flex;align-items:center;gap:12px}',
      '.vgp-m-icon{font-size:1.8rem;flex-shrink:0}',
      '.vgp-m-label{font-size:9px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:#ffd700;font-family:monospace;display:block;margin-bottom:3px}',
      '.vgp-m-product{font-size:1.05rem;font-weight:700;color:#f0f8f8;line-height:1.2;display:block}',
      '.vgp-m-release-info{font-size:11px;color:rgba(0,229,255,.6);display:block;margin-top:3px;letter-spacing:.04em}',
      '.vgp-m-close{position:absolute;top:14px;right:16px;background:none;border:1px solid rgba(0,229,255,.2);color:rgba(0,229,255,.5);width:28px;height:28px;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;border-radius:2px;font-family:monospace;transition:border-color .2s,color .2s}',
      '.vgp-m-close:hover{border-color:#00e5ff;color:#00e5ff}',
      '.vgp-m-body{padding:22px 22px 20px}',
      '.vgp-m-desc{font-size:13px;color:rgba(107,168,168,.9);line-height:1.6;margin-bottom:18px}',
      '.vgp-m-field{display:flex;flex-direction:column;gap:5px;margin-bottom:14px}',
      '.vgp-m-field-label{font-size:10px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#ffd700}',
      '.vgp-m-input{background:#16161a !important;border:1px solid #2a2a32;border-radius:6px;padding:10px 14px;color:#e8e8ec !important;font-family:inherit;font-size:14px;transition:border-color .2s;width:100%;-webkit-appearance:none;appearance:none}',
      '.vgp-m-input:focus{outline:none;border-color:#00e5ff}',
      '.vgp-m-input::placeholder{color:#4a4a5c}',
      '.vgp-m-row{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
      '@media(max-width:420px){.vgp-m-row{grid-template-columns:1fr}}',
      '.vgp-m-submit{width:100%;padding:13px;background:#00e5ff !important;border:none;border-radius:6px;color:#06100f !important;font-family:inherit;font-weight:700;font-size:13px;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;transition:background .2s,transform .15s;margin-top:4px}',
      '.vgp-m-submit:hover{background:#00b3cc !important;transform:translateY(-2px)}',
      '.vgp-m-submit:disabled{opacity:.5;cursor:not-allowed;transform:none}',
      '.vgp-m-gdpr{font-size:11px;color:rgba(107,168,168,.6);margin-top:10px;text-align:center;line-height:1.5}',
      '.vgp-m-gdpr a{color:rgba(0,229,255,.5);text-decoration:none}',
      '.vgp-m-success{text-align:center;padding:2rem 1rem}',
      '.vgp-m-success-icon{font-size:3rem;display:block;margin-bottom:12px}',
      '.vgp-m-success-title{font-size:1.2rem;font-weight:700;color:#00e5ff;display:block;margin-bottom:8px}',
      '.vgp-m-success-sub{font-size:13px;color:rgba(107,168,168,.85);line-height:1.6}',
      '.vgp-m-footer{padding:10px 22px 14px;border-top:1px solid rgba(0,229,255,.1);display:flex;align-items:center;justify-content:center;gap:8px}',
      '.vgp-m-footer-dot{width:4px;height:4px;background:#0d4f4f;border-radius:50%}',
      '.vgp-m-footer-text{font-size:10px;color:rgba(0,229,255,.3);letter-spacing:.1em;text-transform:uppercase}',
      /* Release-Datum Badge auf Karte */
      '.card-release-date{font-size:11px;color:rgba(107,168,168,.7);letter-spacing:.06em;margin-bottom:10px;display:flex;align-items:center;gap:5px}',
      '.card-release-date::before{content:"📅";font-size:10px}'
    ].join('');
    document.head.appendChild(style);
 
    var overlay = document.createElement('div');
    overlay.id = 'vgp-modal-overlay';
    overlay.innerHTML = [
      '<div id="vgp-preorder-modal" role="dialog" aria-modal="true" aria-labelledby="vgp-m-product">',
        '<div class="vgp-m-bar"></div>',
        '<div class="vgp-m-header">',
          '<span class="vgp-m-icon" id="vgp-m-icon">🎮</span>',
          '<div>',
            '<span class="vgp-m-label">Vorbestellung</span>',
            '<span class="vgp-m-product" id="vgp-m-product">Produktname</span>',
            '<span class="vgp-m-release-info" id="vgp-m-release-info"></span>',
          '</div>',
          '<button class="vgp-m-close" id="vgp-m-close" aria-label="Schließen">✕</button>',
        '</div>',
        '<div class="vgp-m-body" id="vgp-m-body">',
          getFormHTML(),
        '</div>',
        '<div class="vgp-m-footer">',
          '<div class="vgp-m-footer-dot"></div>',
          '<span class="vgp-m-footer-text">VideoGamePalace Wien · videogamepalace.at</span>',
          '<div class="vgp-m-footer-dot"></div>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(overlay);
 
    function closeModal() {
      overlay.classList.remove('visible');
      setTimeout(function() {
        overlay.classList.remove('open');
        var body = document.getElementById('vgp-m-body');
        if (body) { body.innerHTML = getFormHTML(); bindForm(); }
      }, 300);
    }
 
    document.getElementById('vgp-m-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });
 
    bindForm();
  }
 
  function getFormHTML() {
    return [
      '<p class="vgp-m-desc">Wir benachrichtigen dich sobald das Produkt bei uns verfügbar ist. Hinterlasse einfach deinen Namen und deine E-Mail-Adresse.</p>',
      '<form id="vgp-preorder-form" novalidate>',
        '<input type="hidden" id="vgp-m-hidden-product" value="">',
        '<div class="vgp-m-row">',
          '<div class="vgp-m-field">',
            '<label class="vgp-m-field-label" for="vgp-m-name">Name *</label>',
            '<input class="vgp-m-input" id="vgp-m-name" type="text" placeholder="Dein Name" required autocomplete="name">',
          '</div>',
          '<div class="vgp-m-field">',
            '<label class="vgp-m-field-label" for="vgp-m-phone">Telefon (optional)</label>',
            '<input class="vgp-m-input" id="vgp-m-phone" type="tel" placeholder="+43 ..." autocomplete="tel">',
          '</div>',
        '</div>',
        '<div class="vgp-m-field">',
          '<label class="vgp-m-field-label" for="vgp-m-email">E-Mail *</label>',
          '<input class="vgp-m-input" id="vgp-m-email" type="email" placeholder="deine@email.at" required autocomplete="email">',
        '</div>',
        '<div class="vgp-m-field">',
          '<label class="vgp-m-field-label" for="vgp-m-note">Anmerkung (optional)</label>',
          '<input class="vgp-m-input" id="vgp-m-note" type="text" placeholder="z.B. gewünschte Edition, Plattform ...">',
        '</div>',
        '<button type="submit" class="vgp-m-submit" id="vgp-m-submit">✉ Vorbestellung absenden</button>',
        '<p class="vgp-m-gdpr">Mit dem Absenden stimmst du unserer <a href="/pages/datenschutz" target="_blank">Datenschutzerklärung</a> zu. Keine Weitergabe an Dritte.</p>',
      '</form>'
    ].join('');
  }
 
  function bindForm() {
    var form = document.getElementById('vgp-preorder-form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('vgp-m-submit');
      var name = document.getElementById('vgp-m-name').value.trim();
      var email = document.getElementById('vgp-m-email').value.trim();
      var phone = (document.getElementById('vgp-m-phone') || {}).value || '';
      var note = (document.getElementById('vgp-m-note') || {}).value || '';
      var product = document.getElementById('vgp-m-hidden-product').value;
 
      if (!name || !email) {
        if (!name) document.getElementById('vgp-m-name').style.borderColor = '#ff4444';
        if (!email) document.getElementById('vgp-m-email').style.borderColor = '#ff4444';
        return;
      }
 
      btn.disabled = true;
      btn.textContent = 'Wird gesendet …';
 
      var body = new URLSearchParams();
      body.append('form_type', 'contact');
      body.append('utf8', '✓');
      body.append('contact[name]', name);
      body.append('contact[email]', email);
      body.append('contact[Telefon]', phone.trim());
      body.append('contact[Produkt]', product);
      body.append('contact[body]',
        'VORBESTELLUNG: ' + product +
        '\nRelease: ' + (document.getElementById('vgp-m-release-info') || {}).textContent +
        (note ? '\n\nAnmerkung: ' + note : '') +
        '\nTelefon: ' + (phone.trim() || '—')
      );
 
      fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body.toString()
      })
      .then(function() { showSuccess(name, product); })
      .catch(function() { showSuccess(name, product); });
    });
  }
 
  function showSuccess(name, product) {
    var mbody = document.getElementById('vgp-m-body');
    mbody.innerHTML = [
      '<div class="vgp-m-success">',
        '<span class="vgp-m-success-icon">✅</span>',
        '<span class="vgp-m-success-title">Vorbestellung eingegangen!</span>',
        '<p class="vgp-m-success-sub">Danke, <strong>' + escHtml(name) + '</strong>!<br>Wir haben deine Anfrage für <strong style="color:#00e5ff">' + escHtml(product) + '</strong> erhalten und melden uns sobald das Produkt verfügbar ist.</p>',
      '</div>'
    ].join('');
    setTimeout(function() {
      var overlay = document.getElementById('vgp-modal-overlay');
      if (overlay) {
        overlay.classList.remove('visible');
        setTimeout(function() { overlay.classList.remove('open'); }, 300);
      }
    }, 3500);
  }
 
  function escHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
 
  /* ══════════════════════════════════
     MODAL ÖFFNEN
  ══════════════════════════════════ */
  window.vgpPreorder = function(id) {
    var p = PRODUCTS.find(function(x) { return x.id === id; });
    if (!p) return;
    var overlay = document.getElementById('vgp-modal-overlay');
    if (!overlay) return;
    document.getElementById('vgp-m-product').textContent = p.title;
    document.getElementById('vgp-m-icon').textContent = p.icon || '🎮';
    document.getElementById('vgp-m-hidden-product').value = p.title;
    var releaseEl = document.getElementById('vgp-m-release-info');
    if (releaseEl) releaseEl.textContent = 'Release: ' + formatRelease(p.release);
    overlay.classList.add('open');
    setTimeout(function() { overlay.classList.add('visible'); }, 10);
    setTimeout(function() {
      var nameInput = document.getElementById('vgp-m-name');
      if (nameInput) nameInput.focus();
    }, 200);
  };
 
  window.vgpToast = function(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function() { t.classList.remove('show'); }, 3500);
  };
 
  /* ══════════════════════════════════
     HELPERS
  ══════════════════════════════════ */
  function pad(n) { return String(n).padStart(2, '0'); }
 
  function countdown(dateStr) {
    var p = dateStr.split('-');
    var target = new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59, 0);
    var diff = target - new Date();
    if (diff <= 0) return null;
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff % 86400000) / 3600000),
      m: Math.floor((diff % 3600000) / 60000),
      s: Math.floor((diff % 60000) / 1000)
    };
  }
 
  function buildCard(p) {
    var cd = countdown(p.release);
    var isReleased = new Date(p.release) <= new Date();
    var badgeLabels = { spiel: 'Spiel', tonie: 'Tonie', konsole: 'Konsole', film: 'Film' };
 
    var cdHtml = '';
    if (!isReleased && cd) {
      cdHtml =
        '<div class="countdown-wrap">' +
          '<div class="countdown-label">RELEASE IN</div>' +
          '<div class="countdown-digits">' +
            '<div class="cd-unit"><span class="cd-num" id="cd-d-' + p.id + '">' + pad(cd.d) + '</span><span class="cd-label">TAGE</span></div>' +
            '<span class="cd-sep">:</span>' +
            '<div class="cd-unit"><span class="cd-num" id="cd-h-' + p.id + '">' + pad(cd.h) + '</span><span class="cd-label">STD</span></div>' +
            '<span class="cd-sep">:</span>' +
            '<div class="cd-unit"><span class="cd-num" id="cd-m-' + p.id + '">' + pad(cd.m) + '</span><span class="cd-label">MIN</span></div>' +
            '<span class="cd-sep">:</span>' +
            '<div class="cd-unit"><span class="cd-num" id="cd-s-' + p.id + '">' + pad(cd.s) + '</span><span class="cd-label">SEC</span></div>' +
          '</div>' +
        '</div>';
    }
 
    var btnHtml = '';
    if (isReleased) {
      var shopUrl = p.url || 'https://videogamepalace.at/collections/all';
      btnHtml = '<a href="' + shopUrl + '" class="btn-preorder">Im Shop ansehen →</a>';
    } else if (p.preorder) {
      btnHtml = '<button class="btn-preorder" onclick="vgpPreorder(' + p.id + ')">Vorbestellen</button>';
    } else {
      btnHtml = '<button class="btn-notify" onclick="vgpToast(\'' + escHtml(p.title) + ' – Du wirst benachrichtigt!\')">Benachrichtigen</button>';
    }
 
    var imgHtml = p.image
      ? '<img src="' + p.image + '" alt="' + escHtml(p.title) + ' Cover" loading="lazy" width="400" height="260">'
      : '<div class="card-image-placeholder"><span class="placeholder-icon">' + (p.icon || '🎮') + '</span><span class="placeholder-label">Bald verfügbar</span></div>';
 
    return [
      '<article class="product-card" id="product-' + p.id + '" data-cat="' + p.cat + '" itemscope itemtype="https://schema.org/Product" style="scroll-margin-top:100px;">',
        '<div class="card-image">',
          imgHtml,
          '<div class="card-category-badge badge-' + p.cat + '">' + (badgeLabels[p.cat] || p.cat) + '</div>',
        '</div>',
        '<div class="card-body">',
          '<div class="card-platform" itemprop="brand">' + p.platform + '</div>',
          '<h2 class="card-title" itemprop="name">' + p.title + '</h2>',
          '<div class="card-release-date">',
            isReleased ? 'Verfügbar seit ' + formatRelease(p.release) : 'Release: ' + formatRelease(p.release),
          '</div>',
          '<p class="card-desc" itemprop="description">' + p.desc + '</p>',
          cdHtml,
          '<div class="card-footer">',
            '<div class="card-price"><span class="price-label">Preis</span>' + p.price + '</div>',
            btnHtml,
          '</div>',
        '</div>',
      '</article>'
    ].join('');
  }
 
  function init() {
    if (!document.getElementById('grid')) return; // Nur auf der Highlights-Seite ausführen
    injectSchema();
    createModal();
 
    var grid = document.getElementById('grid');
    grid.innerHTML = PRODUCTS.map(buildCard).join('');
 
    setInterval(function() {
      PRODUCTS.forEach(function(p) {
        var cd = countdown(p.release);
        var dEl = document.getElementById('cd-d-' + p.id);
        if (!dEl) return;
        if (!cd) {
          var wrap = dEl.closest('.countdown-wrap');
          if (wrap) wrap.innerHTML = '<div class="countdown-released">✓ JETZT VERFÜGBAR</div>';
          return;
        }
        var hEl = document.getElementById('cd-h-' + p.id);
        var mEl = document.getElementById('cd-m-' + p.id);
        var sEl = document.getElementById('cd-s-' + p.id);
        dEl.textContent = pad(cd.d);
        if (hEl) hEl.textContent = pad(cd.h);
        if (mEl) mEl.textContent = pad(cd.m);
        if (sEl) sEl.textContent = pad(cd.s);
      });
    }, 1000);
 
    document.querySelectorAll('.filter-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.filter-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var f = btn.dataset.filter;
        document.querySelectorAll('.product-card[data-cat]').forEach(function(card) {
          card.classList.toggle('hidden', f !== 'all' && card.dataset.cat !== f);
        });
      });
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
